module.exports = __webpack_public_path__ + "img/grate-droplet.126ba0d4.svg";